import f2 from '../img/s6.jpg'
import f3 from '../img/s7.jpg'
import f4 from '../img/s9.jpg'
import f7 from '../img/f4.jpg'

export const heroData = [
    {
        id : 1, name : 'Rice Meal', 
        decp : 'Pork Adobo Rice', 
        price : '49.99', 
        imageSrc : f2, 
    },
    {
        id : 2, name : 'Pizza', 
        decp : 'Pepperoni Pizza', 
        price : '99.99', 
        imageSrc : f3,  
    },
    {
        id : 3, name : 'Burgers', 
        decp : 'Ultimate Beef Burger', 
        price : '39.99', 
        imageSrc : f4, 
    },
    {
        id : 4, name : 'Fries', 
        decp : 'French Fries', 
        price : '45.99', 
        imageSrc : f7, 
    },
];

export const categories = [
    {
        id : 1, 
        name : 'Chickens',
        urlParamName: "Chickens",
    },
    {
        id : 2, 
        name : 'Burgers',
        urlParamName: "Burgers",
    },
    {
        id : 4, 
        name : 'Pizza',
        urlParamName: "Pizza", 
    },
    {
        id : 5, 
        name : 'Pasta',
        urlParamName: "Pasta",
    },
    {
        id : 6, 
        name : 'Rice Meals',
        urlParamName: "Rice Meals", 
    },

    {
        id : 7, 
        name : 'Sides',
        urlParamName: "Sides", 
    },

];

export const restaurants = [

{
    id : 1, 
    name : 'Jollibee',
    urlParamName: "Jollibee",
},
{
    id : 2, 
    name : 'Mcdonalds',
    urlParamName: "Mcdonalds",
},
{
    id : 5, 
    name : 'BurgerKing',
    urlParamName: "BurgerKing", 
},
{
    id : 6, 
    name : 'Kuya J',
    urlParamName: "Kuya J", 
},
{
    id : 7, 
    name : 'Pizza Hut',
    urlParamName: "Pizza Hut", 
},
{
    id : 8, 
    name : 'Mang Inasal',
    urlParamName: "Mang Inasal", 
},
{
    id : 9, 
    name : "Wendy's",
    urlParamName: "Wendy's", 
},
{
    id : 10, 
    name : "KFC",
    urlParamName: "KFC", 
},

{
    id : 11, 
    name : "MAX's",
    urlParamName: "MAX's", 
},
];

